import Dialog from '@mui/material/Dialog'

const ClassBannersAddSuccessModal = ({ open, isEdit, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[420px] !p-[24px] !rounded-[12px] !bg-[#FDFDFD] !shadow-modal-light',
      }}
    >
      <div className="w-full flex flex-col items-center">
        <img
          src="/assets/icon/settings-change-success.svg"
          alt="Success"
          className="w-[124px] h-[124px]"
        />

        <h2 className="mt-[16px] text-xl font-bold text-primary-100">
          Banner Successfully {isEdit ? 'Edited' : 'Created'}
        </h2>

        <h3 className="text-primary-100 text-sm font-medium mt-[8px] text-center">
          Congratulations! Your {isEdit ? '' : 'new '}banner has been successfully{' '}
          {isEdit ? 'edited' : 'created'}.
        </h3>

        <button
          className="mt-[24px] w-full h-[44px] shadow-button bg-primary-button rounded-[8px] flex items-center justify-center text-lg font-semibold text-white hover:bg-primary-button-hover transition-colors duration-200 ease"
          onClick={onClose}
        >
          Continue
        </button>
      </div>
    </Dialog>
  )
}

export default ClassBannersAddSuccessModal
